import React, { Component, Fragment } from "reactn";
import { DialogTitle, DialogActions, Button, TextField } from "@material-ui/core";
import { RowGrid } from "js/react/components/LayoutGrid";
import {
    BeautifulDialog,
    DialogContent,
    ShowSnackBar
} from "js/react/components/Dialogs/BaseDialog";
import { ToggleAllowCommenting } from "../components/ToggleAllowCommenting";
import { Gap20 } from "js/react/components/Gap";
import LinkExpiration from "js/react/components/LinkExpiration";
import { ClipboardType, clipboardWrite } from "js/core/utilities/clipboard";

export default class EditPublicLinkDialog extends Component {
    state = {
        linkShouldExpire: false,
        linkHasExpired: false,
        linkExpiresAt: null,
    };

    componentDidMount() {
        const linkExpiresAt = this.props.link?.get("expiresAt");
        this.setState({
            linkExpiresAt,
        });
    }

    copyToClipboard() {
        const {
            link,
        } = this.props;
        const url = link.getLinkURL();
        clipboardWrite({
            [ClipboardType.TEXT]: url,
        });
        ShowSnackBar({
            message: `Link for ${link.get("name")} was copied to the clipboard`
        });
    }

    handleAccept = link => {
        this.copyToClipboard();
        this.props.closeDialog();
        this.props.callback();
    };

    handleNameChange = name => {
        this.props.link.update({ name });
        this.update();
    }

    toggleAllowCommenting = event => {
        let { link } = this.props;
        if (link) {
            const allowCommenting = !link.attributes.allowCommenting;
            link.update({ allowCommenting });
            this.update();
        }
    }

    handleUpdateLinkExpiration = ({ linkShouldExpire, linkHasExpired, linkExpiresAt }) => {
        this.setState({
            linkShouldExpire,
            linkHasExpired,
            linkExpiresAt
        });

        if (!linkHasExpired) {
            this.props.link.update({
                expiresAt: linkShouldExpire ? linkExpiresAt : null
            });
        }
    }

    update = () => {
        this.forceUpdate();
        this.props.callback();
    }

    render() {
        let {
            link,
            presentation,
        } = this.props;
        const {
            linkHasExpired,
            linkExpiresAt,
        } = this.state;
        const disabled = linkHasExpired || link.isLinkExpired();

        const allowCommenting = link?.get("allowCommenting");

        return (
            <BeautifulDialog closeDialog={this.props.closeDialog}>
                <DialogTitle>Edit Shareable Link</DialogTitle>
                <DialogContent>
                    <RowGrid gap={0}>
                        <TextField
                            label="Link Name"
                            value={link.get("name")}
                            onChange={event => this.handleNameChange(event.target.value)}
                        />
                        <Gap20 />

                        <ToggleAllowCommenting
                            allowCommenting={allowCommenting}
                            onToggle={this.toggleAllowCommenting}
                        />

                        <LinkExpiration expiresAt={linkExpiresAt} presentation={presentation} link={link} onUpdate={this.handleUpdateLinkExpiration} stacked />
                    </RowGrid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.closeDialog}>Close</Button>
                    <Button
                        onClick={() => this.handleAccept(link)}
                        disabled={disabled}
                        color="primary"
                    >
                        Copy Link to Clipboard
                    </Button>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}
